var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('label', {
    staticClass: "tt"
  }, [_vm._v("请选择日期: ")]), _vm._v(" "), _c('j-date-picker', {
    attrs: {
      "width": _vm.width1,
      "placeholder": _vm.placeholder,
      "picker-options": _vm.pickerOptions,
      "rangeSeparator": _vm.rangeSeparator,
      "disabled": _vm.disabled,
      "showLunarClass": _vm.showLunarClass,
      "showLunarControl": _vm.showLunarControl,
      "type": _vm.type,
      "showBackYears": _vm.showBackYears,
      "showLunarIcon": _vm.showLunarIcon,
      "format": _vm.format
    },
    on: {
      "change": _vm.onDateChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tt",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("选择的日期是：" + _vm._s(_vm.value1))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("返回结果：公历：2017-01-01；农历：L2017-01-01；农历闰月：LR2017-06-01; 日期段(公历)：['2017-01-02','2017.02.01'];日期段(农历)：['L2017-01-02','L2017.02.01'];")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "点击提交查看结果"
    },
    on: {
      "click": _vm.onBtnClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "param"
  }, [_c('h4', [_vm._v("设置后需要重新选择日期才能看见更新效果")]), _vm._v(" "), _c('label', [_vm._v("宽度：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width1),
      expression: "width1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.width1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("文本占位：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.placeholder),
      expression: "placeholder"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.placeholder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.placeholder = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("选择范围时的分隔符：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeSeparator),
      expression: "rangeSeparator"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rangeSeparator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeSeparator = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("类型：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DATE"
    }
  }, [_vm._v("DATE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DATERANGE"
    }
  }, [_vm._v("DATERANGE")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("农历显示样式：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarClass),
      expression: "showLunarClass"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showLunarClass = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FULLLUNAR"
    }
  }, [_vm._v("FULLLUNAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LUNAR"
    }
  }, [_vm._v("LUNAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NUMBER"
    }
  }, [_vm._v("NUMBER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MIX"
    }
  }, [_vm._v("MIX")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示农历控制组件：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarControl),
      expression: "showLunarControl"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLunarControl) ? _vm._i(_vm.showLunarControl, null) > -1 : (_vm.showLunarControl)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.showLunarControl,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLunarControl = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLunarControl = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLunarControl = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示农历标记：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarIcon),
      expression: "showLunarIcon"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLunarIcon) ? _vm._i(_vm.showLunarIcon, null) > -1 : (_vm.showLunarIcon)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.showLunarIcon,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLunarIcon = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLunarIcon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLunarIcon = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("禁用：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.disabled) ? _vm._i(_vm.disabled, null) > -1 : (_vm.disabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.disabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disabled = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("文本框可输入：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editable),
      expression: "editable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editable) ? _vm._i(_vm.editable, null) > -1 : (_vm.editable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.editable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.editable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.editable = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示清除按钮：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearable),
      expression: "clearable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearable) ? _vm._i(_vm.clearable, null) > -1 : (_vm.clearable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clearable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clearable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clearable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clearable = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("向后显示年数：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showBackYears),
      expression: "showBackYears"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.showBackYears)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showBackYears = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("格式化：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.format)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.format = $event.target.value
      }
    }
  }), _vm._v(" (不区分大小写)"), _c('br')]), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api"
  }, [_c('h3', [_vm._v("使用说明")]), _vm._v(" "), _c('p', [_vm._v("引入组件并注册：")]), _vm._v(" "), _c('p', [_vm._v("Script:")]), _vm._v(" "), _c('p', {
    staticClass: "js"
  }, [_vm._v("\n      import JDatePicker from '@/components/JDatePicker.vue'\n      "), _c('br'), _vm._v("\n      export default{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "10px"
    }
  }), _vm._v("components:{ JDatePicker },"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "20px"
    }
  }), _vm._v("data:{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v("return{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "40px"
    }
  }), _vm._v("pickerOptions: {"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "50px"
    }
  }), _vm._v("disabledDate (time) {"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "60px"
    }
  }), _vm._v("return time.getTime() < Date.now() - 8.64e7;"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "50px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "40px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "20px"
    }
  }), _vm._v("}"), _c('br'), _vm._v("\n      }\n    ")]), _vm._v(" "), _c('p', [_vm._v("HTML:")]), _vm._v(" "), _c('p', {
    staticClass: "js"
  }, [_vm._v("\n     < j-date-picker v-model=\"value1\" width=\"300\" show-lunar-class=\"fulllunar\" :picker-options=\"pickerOptions\" :show-back-years=\"5\" :show-lunar-control='showLunarControl' show-lunar-icon format=\"yyyy.mm.dd\">< /j-date-picker>\n    ")]), _vm._v(" "), _c('h3', [_vm._v("参数：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("绑定值(v-model);"), _c('br'), _vm._v("时间段模式为字符串数组")]), _vm._v(" "), _c('td', [_vm._v("String,Date,Array")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("类型")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("DATE(日期)"), _c('br'), _vm._v("DATETANGE(时间段)")]), _vm._v(" "), _c('td', [_vm._v("DATE")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("editable")]), _vm._v(" "), _c('td', [_vm._v("文本框可输入;农历模式且展示类型为非'NUMBER'时,为false")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clearable")]), _vm._v(" "), _c('td', [_vm._v("是否显示清除按钮")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("禁用")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("宽度")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("200px/200")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("占位内容")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" - ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-class")]), _vm._v(" "), _c('td', [_vm._v("农历日期的展示类型")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("\n          FULLLUNAR(全农历)"), _c('br'), _vm._v("LUNAR(农历)"), _c('br'), _vm._v("NUMBER(数字)"), _c('br'), _vm._v("MIX(混合)"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("NUMBER")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-icon")]), _vm._v(" "), _c('td', [_vm._v("是否显示农历标记")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-back-years")]), _vm._v(" "), _c('td', [_vm._v("向后展示年数;"), _c('br'), _vm._v("见于年份列表;"), _c('br'), _vm._v("时间段模式无效")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("－")]), _vm._v(" "), _c('td', [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("format")]), _vm._v(" "), _c('td', [_vm._v("时间日期格式化")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("年：YYYY ，月：MM ，日：DD ，时：HH  ，分：MM ，秒：SS")]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-control")]), _vm._v(" "), _c('td', [_vm._v("是否显示农历控制组件")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("range-separator")]), _vm._v(" "), _c('td', [_vm._v("选择范围时的分隔符")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" '-' ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("picker-options")]), _vm._v(" "), _c('td', [_vm._v("参考下表")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" {} ")])])]), _vm._v(" "), _c('h3', [_vm._v("picker-options：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabledDate")]), _vm._v(" "), _c('td', [_vm._v("设置禁用状态，参数为当前日期，要求返回 Boolean")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])]), _vm._v(" "), _c('h3', [_vm._v("事件：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("当input值发生改变时，返回值与文本框一致")]), _vm._v(" "), _c('td', [_vm._v("格式化后的值")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-31297f8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 120
// module chunks = 1